import React from 'react';
import PropTypes from 'prop-types';
import postscribe from 'postscribe';

import config from '../../../config';

class SeaticsPolicyWidget extends React.PureComponent {
  static propTypes = {
    onReady: PropTypes.func,
  };

  static defaultProps = {
    onReady: () => {},
  };

  componentDidMount() {
    this.loadScript();
  }

  loadScript() {
    postscribe('#policies', `<script type="text/javascript" src="${config.policyScriptUrl}"></script>`, {
      afterAsync: this.props.onReady,
    });
  }

  render() {
    return (
      <div id="policies" />
    );
  }
}

export default SeaticsPolicyWidget;



// WEBPACK FOOTER //
// ./src/components/features/SeaticsPolicyWidget/SeaticsPolicyWidget.js